import { connect } from "react-redux";
import { PageBookDetail, PageBookDetailWeb } from "senac-components";
import { commonSlice, contentSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import {
  OptionsItems,
  PageBookDetailPropsDispach,
  PageBookDetailState,
} from "senac-components/dist/pages/Mobile/PageBookDetail";
import { Wrapper, WrapperDispatchProps, WrapperStateProps } from "./Wrapper";
import {
  Content,
  ContentGroup,
  ContentHeaderOptionItem,
  ContentOptionAddReadingList,
  ContentReference,
  MenuOptions,
  ReadingListItem,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import {
  ContentType,
  activeContentAnchor,
  loadAndOpenContent,
  openContent,
  showContentDetail,
} from "../store/reducers/contentSlice";
import {
  FavoritesInternalTag,
  createTagPage,
  deleteContentReference,
  downloadContentReference,
  insertInFavorite,
  insertInTagActiveContent,
  rateActiveContent,
  removeFromFavorite,
  removeFromTagActiveContent,
  unRateActiveContent,
} from "../store/reducers/userDataSlice";
import { RemoteContentDetail } from "../services/contents/IContentService";
import { PageAppointmentsStateProps } from "senac-components/dist/pages/Mobile/PageAppointments";
import { LibrarySections } from "senac-components/dist/pages/Mobile/PageLibrarySection";
import {
  PageBookDetailWebDispach,
  PageBookDetailWebProps,
} from "senac-components/dist/pages/Web/PageBookDetail";
import { collections } from "./mocks";
import { filterContent } from "../store/reducers/common";
import { useState } from "react";
export enum ContentTypeV {
  PDF = "PDF",
  EPUB = "EPUB",
  AUDIOBOOK = "AUDIOBOOK"
}

const getAppointments = (state: RootState) => {
  var pdfdata: OptionsItems[] | undefined = undefined;
  var epubdata: OptionsItems[] | undefined = undefined;
  var activeContent = state.contentState.allContents.find(
    (p) => p.uid == state.contentState.activeContentUid
  );
  var data = state.userDataState.userData.filter(
    (p) =>
      p.targetType == "ManagedContentReference" &&
      p.contextType == "ManagedContent" &&
      p.contextUid == activeContent?.uid
  );

  data.forEach((userData) => {
    var reference = activeContent?.references?.find(
      (r) => r.uid == userData.targetUid
    );
    if (!reference) return;

    const external = JSON.parse(userData.externalData);

    var option: OptionsItems & { markColor: any, externalType?: string }= {
      uid: userData.uid,
      title: userData.description,
      marked: userData.annotation,
      numerReading: "0",
      markColor: external.mark_color,
    };

    try {
      var info = JSON.parse(userData.externalData);
      // console.log("info:", info);
      option.numerReading = info.chapter_index;
      option.externalType = userData.externalType
      // option.markColor = info.mark_color;
    } catch (e) {}

    switch (reference.mimeType) {
      case "application/epub+zip": {
        if (!epubdata) epubdata = [];
        epubdata.push(option);
        break;
      }
      case "digitalpages/richpack": {
        if (!pdfdata) pdfdata = [];
        pdfdata.push(option);
        break;
      }
    }
  });

  let result = {
    pdfAppointments: pdfdata,
    epubAppointments: epubdata,
  };

  return result;
};

const listState = (state: RootState) => {
  const activeContent = state.contentState.allContents.find(
    (p) => p.uid == state.contentState.activeContentUid
  );
  const content = { ...(activeContent ?? { uid: "-" }) };
  var data = state.userDataState.userData.filter(
    (p) =>
      p.tags &&
      p.tags.length > 0 &&
      p.targetType == "ManagedContent" &&
      p.contextType == "ManagedContent" &&
      p.contextUid == content.uid
  );
  var uniqueTags = data
    .map((p) => p.tags ?? [])
    .reduce(
      (p, c) => [...new Map([...c, ...p].map((p) => [p.uid, p])).values()],
      []
    );

  const selectedList = uniqueTags.map((p) => p.uid);
  const available = state.userDataState.tags?.filter(
    (t) => t.name != FavoritesInternalTag
  );

  let result = {
    selected: selectedList,
    itemsLists: available,
  };
  return result;
};
const mapState = (state: RootState, props: any) => {
  let contents: ContentGroup[] = [];
  const contentSummary = state.contentState.contentSummary;

  var allContents = state.contentState.allContents;
  var relatedContent = state.contentState.activeContentRelated;
  var activeContent = allContents.find(
    (p) => p.uid == state.contentState.activeContentUid
  );

  var data = state.userDataState.userData.filter(
    (p) =>
      p.tags &&
      p.tags.length > 0 &&
      p.targetType == "ManagedContent" &&
      p.contextType == "ManagedContent"
  );
  var uniqueTags = data
    .map((p) => p.tags ?? [])
    .reduce(
      (p, c) => [...new Map([...c, ...p].map((p) => [p.uid, p])).values()],
      []
    )
    .filter((p) => p.name == FavoritesInternalTag);
  var contentsUids = data
    .filter(
      (p) =>
        p.tags &&
        p.tags.filter((t) => uniqueTags.find((ut) => ut.uid == t.uid)).length >
          0
    )
    .map((p) => p.contextUid);

  var s = contentsUids;
  if (relatedContent) {
    contents.push({
      uid: "related",
      title: "Quem leu também gostou",
      books: allContents.filter((p) => relatedContent?.find((t) => t == p.uid)),
    });
  }

  const content: RemoteContentDetail = {
    ...(activeContent ?? {
      uid: "-",
      readingTime: "",
      title: "Carregando...",
      author: "-",
    }),
  };

  const isFavorite = contentsUids.find((p) => p == content.uid) != undefined;
  const availableEpubFormat =
    content.references?.find((f) => f.mimeType.indexOf("epub") != -1) !=
    undefined;
  const availablePdfFormat =
    content.references?.find((f) => f.mimeType.indexOf("richpack") != -1) !=
    undefined;

  const availableAudioFormat =
    content.references?.find((f) => f.mimeType.indexOf("audiobook") != -1) !=
    undefined;

  let formats = ""; //"ePUB | PDF";

  if (availableEpubFormat) formats += "ePUB";
  if (availablePdfFormat) {
    if (formats.length > 1) formats += " | ";
    formats += "PDF";
  }
  if (availableAudioFormat) {
    if (formats.length > 1) formats += " | ";
    formats += "AUDIOBOOK";
  }

  if (state.userState.user) {
    formats = content?.readingTime
      ? `${content.readingTime} de leitura`
      : "Não estimado tempo de leitura";
  }

  const propsAppointments = getAppointments(state);

  const listResult = listState(state);

  let result: PageBookDetailState &
    WrapperStateProps &
    Partial<PageBookDetailWebProps> = {
    authenticatedUser: state.userState.user !== undefined,
    loading: !content,
    contents: contents, //todo: tratar caso é nulo
    content: content,
    contentsFavorited: isFavorite ? [content.uid] : [],
    contentsDownloaded: [],
    element: window.innerWidth < 1024 ? PageBookDetail : PageBookDetailWeb, //todo: tratar caso onde é nulo
    note: formats,
    availableEpubFormat: availableEpubFormat,
    availablePdfFormat: availablePdfFormat,
    availableAudioFormat: availableAudioFormat,
    references: state.contentState.preferences,
    summaries: contentSummary,
    epubAppointments: propsAppointments.epubAppointments,
    pdfAppointments: propsAppointments.pdfAppointments,
    isFavorite: isFavorite,
    loadingRelateds: state.contentState.loadingRelateds,
    loadingSummary: state.contentState.loadingSummary,
    ...listResult,
  };
  return result;
};

const mapDispatch = (dispatch: AppDispatch, props: any) => {

  const result: PageBookDetailPropsDispach & WrapperDispatchProps &Partial<PageBookDetailWebDispach> = {

    onClickOptionFooter(option) {
      return dispatch(commonSlice.actions.goToMyProfileOption(option));
    },
    onClickLogin: () => dispatch(commonSlice.actions.loginOptionsPage()),
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (
      option: ContentHeaderOptionItem | LibrarySections
    ) => {
      const { name } = option as ContentHeaderOptionItem;

      if (name && name === "Adicionar Lista") {
        return dispatch(
          commonSlice.actions.goToLibraryPage(
            option as unknown as LibrarySections
          )
        );
      }
      return dispatch(
        contentSlice.actions.goToContentInfo(
          option as unknown as ContentHeaderOptionItem
        )
      );
    },
    onRemoveRating: () => {
      dispatch(unRateActiveContent(""));
      console.log("Event dispatch");
    },
    onSelectedNavigationPageOption: (option: MenuOptions) =>
      dispatch(commonSlice.actions.goToPage(option)),
    onClickReadSample: () =>
      dispatch(openContent([ContentType.Epub, ContentType.Pdf])),
    onClickReadEpub: () => dispatch(openContent([ContentType.Epub])),
    onClickReadPdf: () => dispatch(openContent([ContentType.Pdf])),
    onClickOpenAudiobook: () => dispatch(openContent([ContentType.Audiobook])),
    onClickHelp: () => dispatch(commonSlice.actions.helpPage()),
    onSelectedEditionEpub: (content: Content) =>
      dispatch(loadAndOpenContent(content.uid)),
    onRate: (rate: number) => dispatch(rateActiveContent(rate)),
    onDownloadContent: (reference: ContentReference) =>
      dispatch(downloadContentReference(reference.uid)),
    onDeleteContent: (reference: ContentReference) =>
      dispatch(deleteContentReference(reference.uid)),
    onChangeFilter: (filter) => {
      if (filter.query == undefined) return;
      dispatch(filterContent({ query: filter.query }));
    },
    onSelectedContent: (content) => {
      if (!content.uid) return;

      dispatch(showContentDetail(content.uid));
    },
    onCreateList: () => dispatch(createTagPage()),
    onSelectItemChange: (item: ReadingListItem, status: boolean) => {
      if (status) {
        dispatch(insertInTagActiveContent(item.uid));
      } else {
        dispatch(removeFromTagActiveContent(item.uid));
      }
    },
    onClickFavorite(content, isFavorite) {
      if (isFavorite) {
        return dispatch(removeFromFavorite(content));
      }
      return dispatch(insertInFavorite(content));
    },
    onNavigateToContentLink(contentLink, contentType) {
      dispatch(activeContentAnchor({ contentLink, contentType}))
    }
  };

  return result;
};

const WPageBookDetail = connect(mapState, mapDispatch)(Wrapper);

export { WPageBookDetail };
